import { useEffect } from 'react';

const SITE = 'https://www.kevin-gelineau.fr';
const DEFAUT = {
  title: 'Kévin Gelineau — UX/UI Designer & Intégrateur Front-End | Angers',
  description:
    "Portfolio de Kévin Gelineau, UX/UI Designer basé à Angers. Design d'interfaces, prototypage Figma et intégration front-end. Disponible en freelance et en agence."
};

const poser = (selecteur, attribut, valeur) => {
  let el = document.head.querySelector(selecteur);
  if (!el) {
    el = document.createElement(selecteur.startsWith('link') ? 'link' : 'meta');
    const [, cle, nom] = selecteur.match(/\[(.+?)="(.+?)"\]/) || [];
    if (cle) el.setAttribute(cle, nom);
    document.head.appendChild(el);
  }
  el.setAttribute(attribut, valeur);
};

/**
 * Met à jour titre, description, Open Graph et canonical selon la page.
 *
 * Le site est une application monopage : un seul `index.html` sert toutes les
 * routes, donc sans ça chaque page projet hériterait du titre de l'accueil.
 * Google exécute le JavaScript et lit ces valeurs ; les aperçus de partage
 * (LinkedIn, Slack) lisent le HTML brut et garderont ceux d'`index.html`.
 */
export function useMeta({ title, description, image, path } = {}) {
  useEffect(() => {
    const t = title ? `${title} | Kévin Gelineau` : DEFAUT.title;
    const d = description || DEFAUT.description;
    const url = SITE + (path || '/');

    document.title = t;
    poser('meta[name="description"]', 'content', d);
    poser('meta[property="og:title"]', 'content', t);
    poser('meta[property="og:description"]', 'content', d);
    poser('meta[property="og:url"]', 'content', url);
    poser('link[rel="canonical"]', 'href', url);
    if (image) poser('meta[property="og:image"]', 'content', SITE + image);

    return () => {
      document.title = DEFAUT.title;
    };
  }, [title, description, image, path]);
}
